import { AxiosError } from 'axios'
import { Result, err, ok } from 'neverthrow'
import { MaestroClient } from 'src/httpClients/baseClients/maestro'
import {
    ClientResponseType,
    ExpertsDataClientReqType,
    ExpertProfileClientRespType,
    ExpertsDataClientRespType,
    ExportListClientRespType,
    ExportClientReqType,
    LanguageListClientRespType,
    SkillClientRespType,
} from 'src/types/api.types'
import { Endpoints } from 'src/constants/api.constants'

export const getListOfLanguagesApi = async (): Promise<
    Result<LanguageListClientRespType[], AxiosError>
> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Languages)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getListOfCountriesApi = async (): Promise<Result<ClientResponseType, AxiosError>> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Countries)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getListOfEducationMajorsApi = async (): Promise<
    Result<ClientResponseType, AxiosError>
> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Majors)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getListOfOccupationsApi = async (): Promise<
    Result<ClientResponseType, AxiosError>
> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Occupations)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getListOfDegreesApi = async (): Promise<Result<ClientResponseType, AxiosError>> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Degrees)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getSkillsApi = async (): Promise<Result<SkillClientRespType, AxiosError>> => {
    try {
        const resp = await MaestroClient.get(Endpoints.Skills)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getExpertsListApi = async (
    payload: ExpertsDataClientReqType
): Promise<Result<ExpertsDataClientRespType, AxiosError>> => {
    try {
        const resp = await MaestroClient.post(Endpoints.GetExperts, payload)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getExportExpertDetailsApi = async (
    payload: ExportClientReqType
): Promise<Result<ExportListClientRespType, AxiosError>> => {
    try {
        const resp = await MaestroClient.post(Endpoints.ExportExpertDetails, payload)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getExpertsProfileApi = async (
    clientId: string
): Promise<Result<ExpertProfileClientRespType, AxiosError>> => {
    try {
        const resp = await MaestroClient.get(`${Endpoints.ExpertProfile}/${clientId}`)
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}
